import React from "react";

const Error = () => {
  return (
    <div className='section section-center text-center '>
      <h2 className='text-3xl capitalize text-gray-800 font-semibold'>
        there was an error
      </h2>
    </div>
  );
};

export default Error;
